import React from "react";
import { StyleProp, ViewStyle } from "react-native";

import { useTheme } from "../AHTheme/AHTheme";
import { Box } from "../AHTheme/Box";
import { BoxProps } from "../AHTheme/BoxProps";

export const AHSeparator = ({
  style,
  ...boxProps
}: { style?: StyleProp<ViewStyle> } & BoxProps) => {
  const color = useTheme()["border-primary"];
  return (
    <Box {...boxProps}>
      <Box
        borderColor="border-primary"
        style={[
          {
            alignSelf: "stretch",
            backgroundColor: color,
            borderBottomWidth: 1,
          },
          style,
        ]}
      />
    </Box>
  );
};
